import { defineStore } from 'pinia';

export interface AlertDataItem {
  isShow: boolean,
  isShowTitle?:boolean,
  title?: string,
  message?: string,
  info?:string,
  size?:string,
  cancelText?: string,
  confirmText?: string,
  confirmCallback?: null | Function,
}
const defaultAlertData = {
  isShow: false,
  isShowTitle:false,
  title: '',
  message: '에러가 발생했습니다.',
  info: '',
  size:'sm',
  cancelText: '취소',
  confirmText: '확인',
  confirmCallback: null
};
export const useAlertStore = defineStore('alert', {
  state: ():AlertDataItem => {return {...defaultAlertData};},
  actions: {
    setAlert(payload:AlertDataItem){
      Object.assign(this.$state, payload);
    },
    removeAlert(){
      Object.assign(this.$state, defaultAlertData);
    },
  }
});
